import { ContentView } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/RequestKycModal/ContentView';
import { StyledModal } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/RequestKycModal/styles';
import { useForm } from 'react-hook-form';
import { RequestKycDto } from '@dealstack/shared/lib/generated';

interface Props {
	investorIds: string[];
	bulkActionPayload?: Omit<RequestKycDto, 'customizedEmailBody'>;
	totalRecipients?: number;
	onClose: () => void;
	sendKycRequest: (payload: RequestKycDto) => Promise<void>;
}

export const RequestKycModal = ({
	investorIds,
	bulkActionPayload,
	totalRecipients,
	onClose,
	sendKycRequest,
}: Props) => {
	const form = useForm<{ customizedEmailBody: string; sendNotification: boolean }>({
		mode: 'all',
		defaultValues: { customizedEmailBody: '', sendNotification: true },
	});

	const onConfirm = async () => {
		const { customizedEmailBody, sendNotification } = form.getValues();
		await sendKycRequest({
			...(bulkActionPayload ?? { selectedIds: investorIds }),
			customizedEmailBody: sendNotification ? customizedEmailBody || undefined : undefined,
			sendNotification,
		});
		onClose();
	};

	return (
		<StyledModal contentLabel="request-kyc-modal" isOpen>
			<ContentView
				onClose={onClose}
				onConfirm={onConfirm}
				investorCount={totalRecipients ?? investorIds.length}
				form={form}
			/>
		</StyledModal>
	);
};
